'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroup$002dRestrictions$002dView$0024$0024anon$002461 from "./presto.-Group-Restrictions-View$$anon$61.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$0024 from "./presto.types$-Grouping$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dDescription$0024 from "./presto.types$-Grouping-Description$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dId$0024 from "./presto.types$-Grouping-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dKind$0024 from "./presto.types$-Grouping-Kind$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024 from "./presto.types$-Grouping-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupRestrictionsView$$anon$60() {
  this.aVc = null;
  this.aV4 = null;
  this.aV5 = false;
  this.aVd = null;
  this.aVe = false;
  this.aVh = null;
  this.aVa = null;
  this.aVb = false;
  this.aV6 = null;
  this.aV7 = false;
  this.aV8 = null;
  this.aV9 = false;
  this.aVf = false;
  this.aVg = false;
  this.aVc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aVh = "Grouping";
}
export { $c_Lpresto_GroupRestrictionsView$$anon$60 as $c_Lpresto_GroupRestrictionsView$$anon$60 };
$p = $c_Lpresto_GroupRestrictionsView$$anon$60.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupRestrictionsView$$anon$60;
/** @constructor */
function $h_Lpresto_GroupRestrictionsView$$anon$60() {
}
export { $h_Lpresto_GroupRestrictionsView$$anon$60 as $h_Lpresto_GroupRestrictionsView$$anon$60 };
$h_Lpresto_GroupRestrictionsView$$anon$60.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aVc;
});
$p.L = (function() {
  if ((!this.aV5)) {
    this.aV4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aV5 = true;
  }
  return this.aV4;
});
$p.O = (function() {
  if ((!this.aVe)) {
    this.aVd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aVe = true;
  }
  return this.aVd;
});
$p.E = (function() {
  return this.aVh;
});
$p.t = (function() {
  if ((!this.aVb)) {
    this.aVa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("description", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.aVb = true;
  }
  return this.aVa;
});
$p.M = (function() {
  if ((!this.aV7)) {
    this.aV6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dId$0024.$m_Lpresto_types$GroupingId$().nK(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dGrouping$002dKind$0024.$m_Lpresto_types$GroupingKind$().p4())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dName$0024.$m_Lpresto_types$GroupingName$().nL(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dDescription$0024.$m_Lpresto_types$GroupingDescription$().p3(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.aV7 = true;
  }
  return this.aV6;
});
$p.Q = (function() {
  if ((!this.aV9)) {
    this.aV8 = new $j_presto$002e$002dGroup$002dRestrictions$002dView$0024$0024anon$002461.$c_Lpresto_GroupRestrictionsView$$anon$61();
    this.aV9 = true;
  }
  return this.aV8;
});
$p.w = (function() {
  if ((!this.aVg)) {
    this.aVf = false;
    this.aVg = true;
  }
  return this.aVf;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee448) => ((p) => \u03b4scrutinee448.p0(p)))($j_presto$002etypes$0024$002dGrouping$0024.$m_Lpresto_types$Grouping$())));
});
var $d_Lpresto_GroupRestrictionsView$$anon$60 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupRestrictionsView$$anon$60, "presto.GroupRestrictionsView$$anon$60", ({
  J5: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_GroupRestrictionsView$$anon$60 as $d_Lpresto_GroupRestrictionsView$$anon$60 };
//# sourceMappingURL=presto.-Group-Restrictions-View$$anon$60.js.map
